import { mapProps } from 'recompose';
import { countries } from '../constants';
import { getCountryValueFromKey } from './countryHelper';

export const processChannelCountryAnalytics = countryResponse => {
  // result: {
  //   columnHeaders: [ array of objects
  //     {
  //       name: country,
  //       columnType,
  //       dataType
  //     },
  //     {
  //       name: views,
  //       columnType,
  //       dataType
  //     }
  //   ],
  //   rows: [ array of arrays
  //     [
  //       "{countryCode}",
  //       {views} (integer)
  //     ],
  //     [...],
  //     [...]
  //   ]
  // }

  if (
    countryResponse &&
    countryResponse.result &&
    countryResponse.result.rows &&
    countryResponse.result.rows.length
  ) {
    return countryResponse.result.rows.map(countryViews => {
      const countryName = getCountryValueFromKey(countryViews[0]);
      return {
        countryName,
        views: countryViews[1]
      };
    });
  }
  return [];
};



// WEBPACK FOOTER //
// ./src/helpers/youtubeResponseHandler.js